// Inactivated / inactivating students get a red card in the class lists.
export function isInactiveRegistration(status) {
  return status === 'inactivated' || status === 'inactivating';
}

// Badge colours for a student's registration status. `strong` is the darker
// variant used on tinted rows.
export function registrationStatusClass(status, strong = false) {
  const tones = {
    active: ['bg-green-100 text-green-700', 'bg-green-200 text-green-800'],
    pending: ['bg-amber-100 text-amber-700', 'bg-amber-200 text-amber-800'],
    suspending: ['bg-orange-100 text-orange-700', 'bg-orange-200 text-orange-800'],
    suspended: ['bg-orange-100 text-orange-700', 'bg-orange-200 text-orange-800'],
    inactivating: ['bg-red-100 text-red-700', 'bg-red-200 text-red-800'],
    inactivated: ['bg-red-100 text-red-700', 'bg-red-200 text-red-800'],
  };
  const [light, dark] = tones[status] || ['bg-gray-100 text-gray-700', 'bg-gray-200 text-gray-700'];
  return strong ? dark : light;
}
